import { v1 as uuidV1 } from 'uuid'

export default {
  v1: uuidV1,
}
